import {
  Component,
  OnInit
} from '@angular/core';
import {
  PaypalManagementService
} from '../../services/PaypalManagement.service';
import {
  PaypalProductModal
} from '../../models/PaypalProduct.model';
import {
  Router
} from '@angular/router';
import {
  DomSanitizer
} from '@angular/platform-browser';

@Component({
  selector: 'app-paypal-management',
  templateUrl: './paypal-management.component.html',
  styleUrls: ['./paypal-management.component.css']
})

export class PaypalManagementComponent implements OnInit {
  productsList: any[] = [];
  allProducts: any[] = [];
  product: PaypalProductModal;
  showOverlayBuyIps: boolean = false;
  promoId: string = "";
  quantity: number = 1;
  description: string = "";
  url: string = "";
  constructor(private _service: PaypalManagementService, private router: Router, private _sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.showOverlayBuyIps = true;
    this.getProducts();
  }

  getProducts() {
    this._service.getProducts().subscribe((data: any[]) => {
      this.allProducts = data;
      this.productsList = this.allProducts.filter(i => i.productType == 1);
      this.productsList.forEach(i => {
        i.amount += this.allProducts.filter(j => j.productType == 4)[0].amount;
      });
      this.showOverlayBuyIps = false;
    });
  }

  buyProduct(id) {
    let addOnArray = [];
    let BuyProductModalSent = [];
    this.router.navigate(['BuyIPSProductPromo'], {
      queryParams: {
        'promoId': this.promoId,
        'productSelected': id,
        'productQty': this.quantity,
        'promoName': "",
        'addOnPrevious': JSON.stringify(addOnArray),
        'addOnPreviousComplete': JSON.stringify(addOnArray),
        'BuyProductModalSent': JSON.stringify(BuyProductModalSent)
      },
      skipLocationChange: true
    })
  }

  helpVideoOpen(category) {
    if (category == '1') {
      this.url = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/VHPthon0YFw") as string;
      this.description = "Buy Using PayPal";
    } else {
      this.url = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/uHiR-kBszi0") as string;
      this.description = "Buy Using Credit Card";
    }
  }

  closeHelpVideo() {
    this.url = null;
    this.description = "";
  }
}
